//
// lazy-loaded-image.js
//
// Copyright (c) 2014 by Curalate, Inc.
//

/*global angular: false*/

(function() {
    "use strict";

    angular.module('curalate').directive('lazyLoadedImage', function() {
        return {
            restrict: 'AC',
            scope: {
                src: '@lazySrc'
            },
            transclude: true,
            controller: ['$scope',
            function($scope) {
                $scope.loaded = false;
                $scope.loading = false;
            }],
            link: function(scope, element) {
                var ACORN_IMAGE_URL = '/images/acorn.svg';

                var onLoadFunc = function() {
                    // Once the image is loaded, remove the listener we attached to inview to save cycles in the case
                    // where this directive is attached to many elements on a single page.
                    element.off('inview');

                    element.addClass('loaded');

                    scope.$evalAsync(function() {
                        scope.loaded = true;
                        scope.loading = false;
                    });
                };

                var attachReadyHandler = function(elt) {
                    var img = new Image();
                    img.onload = img.onreadystatechange = function() {
                        img = null;
                        elt.css('background-image', 'url(' + scope.src + ')');
                        onLoadFunc();
                    };
                    img.src = scope.src;
                };

                element.on('inview', function(event, isInView) {
                    if (!scope.loaded && !scope.loading && isInView) {
                        // Denote that the image is now loading
                        scope.$evalAsync(function() {
                            scope.loading = true;
                        });

                        // Start loading the image
                        switch(element[0].nodeName) {
                            case 'IMG': {
                                // When the image is finished loading, update the element's loading status
                                element.on('load', onLoadFunc);
                                element.attr('src', scope.src);
                                break;
                            }
                            case 'DIV': {
                                //  If the element is a container for image loads
                                if (element.children('[lazy-target]').length > 0) {
                                    $.each(element.children('[lazy-target]'), function(idx, el) {
                                        var childElm = $(el);
                                        if (childElm[0] && childElm[0].nodeName === 'IMG') {
                                            // When the image is finished loaded, update the scope
                                            childElm.on('load', onLoadFunc);
                                            childElm.attr('src', scope.src);
                                        } else {
                                            attachReadyHandler(childElm);
                                        }
                                    });
                                } else {
                                    attachReadyHandler(element);
                                }
                                break;
                            }

                            default: {
                                attachReadyHandler(element);
                                break;
                            }
                        }
                    }
                });

                // Binds to this event for only one trigger so we don't get stuck
                // in an infinite loop if the acorn image is broken
                element.one('error', function(event) {
                    // When the image is finished loading, update the element's loading status
                    element.on('load', onLoadFunc);
                    element.attr('src', ACORN_IMAGE_URL);
                });
            }
        };
    });

})();
